import { toast } from 'react-toastify';

import { MINIMUM_REQUIRED_SENTENCE_LENGTH } from '../../../../constants';

import type { IBtSupervision } from '../../../../utils/types';

export const validateSupervision = (btSN: IBtSupervision) => {
  if (!btSN) return false;

  const { additional_comments } = btSN;

  if (
    !btSN.has_materials_organized_prior_to_session ||
    !btSN.builds_rapport_with_learner ||
    !btSN.implements_programs_and_collects_data_regularly ||
    !btSN.provides_clear_sds_and_keeps_appropriate_pace ||
    !btSN.varies_reinforces_assesses_as_needed ||
    !btSN.provides_praise_for_independent_responses ||
    !btSN.uses_appropriate_ratio_of_mastered_novel_tasks ||
    !btSN.uses_prompts_appropriately ||
    !btSN.implements_correction_procedures_appropriately ||
    !btSN.uses_more_positive_than_corrective_statements ||
    !btSN.uses_non_verbal_prompts_when_possible ||
    !btSN.remains_calm_during_challenging_behaviors ||
    !btSN.follows_behavior_protocol_and_records_data_as_outlined ||
    !btSN.professionalism ||
    !btSN.collaborates_effectively_with_colleagues ||
    !btSN.seeks_feedback_for_growth_in_clinical_skills
  ) {
    toast.error('At least one checkbox in each row must be selected');
    return false;
  }

  if (
    !additional_comments ||
    additional_comments.trim().length < MINIMUM_REQUIRED_SENTENCE_LENGTH
  ) {
    toast.error(
      `Additional comments should have minimum ${MINIMUM_REQUIRED_SENTENCE_LENGTH} characters`,
    );
    return false;
  }

  return true;
};
